/**
 * Shareable guest demo entry: cold visitors land on a pre-scanned Continuity
 * Guardian finding (Watson's wound) without hunting through the dashboard.
 */

/** The Holmes combined novel that holds the shoulder-vs-leg finding. */
export const GUEST_DEMO_PROJECT_TITLE =
  "A Study in Scarlet and The Sign of Four" as const;

/** Query flag accepted by POST /api/auth/guest and /demo. */
export const GUEST_DEMO_ID = "watson-wound" as const;

export function guestDemoProjectPath(projectId: string): string {
  return `/project/${projectId}?tab=analysis&view=ai-continuity`;
}

/** Short labels for guest-setup progress copy (not the full project titles). */
export function guestSampleDisplayName(title: string): string {
  if (title === GUEST_DEMO_PROJECT_TITLE) return "Sherlock Holmes";
  if (title === "Moby-Dick") return "Moby-Dick";
  if (title === "The Four Gospels (KJV)") return "The Four Gospels";
  return title;
}
